import React from 'react';
import failedIcon from '@assets/images/icons/fail.svg';
import warningIcon from '@assets/images/icons/warning.svg';
import {VerificationType} from '@src/types';
import '@components/verification/verification.scss';

interface IVerifyProps {
  type: VerificationType,
  title: string,
  desc: string
}

const Verification = ({type, title, desc}: IVerifyProps) => {
  return (
    <div className={`card card-verification card-verification--${type.toLowerCase()}`}>
      <h5 className="card-title icon-text"><img src={type === VerificationType.FAILED ? failedIcon : warningIcon} alt=""/> <span className="icon-text_content">{title}</span></h5>
      <div className="card-body">
        <p className="card-text" dangerouslySetInnerHTML={{ __html: desc }}></p>
        <a href="https://www.fibretrace.io">www.fibretrace.io</a>
      </div>
    </div>
  );
}

export default Verification;
